import React from 'react';
import { CheckboxUI, DebouncedInputUI, StaticDatePickerUI } from '../../../Interface';
import dayjs from 'dayjs';
import { SimpleTreeView, TreeItem } from '@mui/x-tree-view-pro';
import { Box, Typography } from '@mui/material';

const CalendarFilter = ({ dates, resources, queryState, hasResourceFilter, isLgUp }) => {
  const { date, setDate } = dates;
  const { query, setQuery } = queryState;

  const items = query.filter?.filterModel?.items ?? [];

  const handleFilterChange = (field, value, id = null, operator) => {
    setQuery((prev) => {
      let newItems = prev.filter.filterModel.items.filter((item) => item.field !== field);

      if (value !== null && value !== '') {
        newItems.push({
          id,
          field,
          operator: operator ?? 'is',
          value,
        });
      }

      return {
        ...prev,
        filter: {
          filterModel: {
            items: newItems,
            logicOperator: 'and',
          },
        },
      };
    });
  };

  const getFieldItem = (field) => items.find((item) => item.field === field);

  const isChecked = (id) => {
    const field = 'projectId';
    const item = getFieldItem(field);
    if (!item || !Array.isArray(item.value)) return false;
    return item.value.map(String).includes(String(id));
  };

  const handleToggle = (id) => {
    const field = 'projectId';

    setQuery((prev) => {
      const prevItems = prev.filter.filterModel.items || [];
      const existing = prevItems.find((item) => item.field === field);

      let newItems;

      if (!existing) {
        newItems = [
          ...prevItems,
          {
            field,
            operator: 'isAnyOf',
            value: [id],
          },
        ];
      } else {
        const currentValues = Array.isArray(existing.value) ? existing.value : [];
        const exists = currentValues.map(String).includes(String(id));

        let updatedValues;
        if (exists) {
          updatedValues = currentValues.filter((v) => String(v) !== String(id));
        } else {
          updatedValues = [...currentValues, id];
        }

        if (updatedValues.length === 0) {
          newItems = prevItems.filter((item) => item !== existing);
        } else {
          newItems = prevItems.map((item) => (item === existing ? { ...item, value: updatedValues } : item));
        }
      }

      return {
        ...prev,
        filter: {
          ...prev.filter,
          filterModel: {
            ...prev.filter.filterModel,
            items: newItems,
            logicOperator: 'and',
          },
        },
      };
    });
  };

  return (
    <div>
      {isLgUp && (
        <>
          <div className="w-full">
            <StaticDatePickerUI
              sx={{
                '& .MuiDatePickerToolbar-root': {
                  display: 'none',
                },
                '& .MuiDialogActions-root': {
                  display: 'none',
                },
                ' & .MuiDateCalendar-root': {
                  background: '#f3f4f6',
                },
              }}
              value={dayjs(date)}
              onChange={(newDate) => {
                setDate((prevState) => ({
                  ...prevState,
                  startDate: newDate ? newDate.startOf('day') : null,
                  endDate: newDate ? newDate.endOf('day') : null,
                }));
              }}
            />
          </div>
          <Box ml={1}>
            <DebouncedInputUI
              size="small"
              placeholder="Projekt keresés…"
              debounceMs={800}
              variant="outlined"
              setQuickFilterSearchValue={(newValue) => {
                handleFilterChange('project', newValue, null, 'contains');
              }}
              quickFilterSearchValue={query?.filter?.filterModel?.items?.find((i) => i.field === 'project')?.value}
              disabled={!hasResourceFilter}
            />
          </Box>

          <Box ml={1} my={2}>
            <DebouncedInputUI
              size="small"
              placeholder="Feladat keresés…"
              debounceMs={800}
              variant="outlined"
              setQuickFilterSearchValue={(newValue) => {
                handleFilterChange('simpleTaskName', newValue, null, 'contains');
              }}
              quickFilterSearchValue={
                query?.filter?.filterModel?.items?.find((i) => i.field === 'simpleTaskName')?.value
              }
              disabled={!hasResourceFilter}
            />
          </Box>
        </>
      )}

      <SimpleTreeView>
        <TreeItem itemId="groups-root" label="Projektek">
          {resources.project?.map((item) => (
            <TreeItem
              key={`group-${item.projectId}`}
              itemId={`group-${item.projectId}`}
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }} onClick={(e) => e.stopPropagation()}>
                  <CheckboxUI
                    sx={{ m: 0, p: 0 }}
                    checked={isChecked(item.projectId)}
                    onChange={() => handleToggle(item.projectId)}
                  />
                  <Typography>{item.projectName}</Typography>
                </Box>
              }
            />
          ))}
        </TreeItem>
      </SimpleTreeView>
    </div>
  );
};

export default CalendarFilter;
